import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Flex, Text, Image } from '@chakra-ui/core';
import moment from 'moment';

import { formatDollar } from '../../../utils/CurrencyFormatter';
import Button from '../../helpers/Button';

const AddFarm = ({ menuOpen, products }) => {
  const history = useHistory();
  return (
    <Box className={menuOpen ? 'px-8' : 'px-4'}>
      <Box mx="auto" className="container">
        <Flex wrap="wrap" justify="space-around">
          {products.map((product, i) => (
            <Box key={product._id} mb={{ base: 12, md: 0 }} w="56">
              {product.status === 2 ? (
                <>
                  <Box className="shadow-cfw" pos="relative" mb="3">
                    <Box className="rounded-md" p="4" mt={10} bg="white" textAlign="center">
                      <Text className="text-sm" fontWeight="bold">
                        {product.crop.name}
                      </Text>
                      <Text as="span" className="text-xs">
                        {product.acreage} Acres
                      </Text>
                      <Image
                        w="32"
                        mx="auto"
                        mb="4"
                        src={product.crop.imageUrl}
                        alt={product.crop.name}
                      />
                    </Box>
                    <Text
                      as="span"
                      p="2"
                      pos="absolute"
                      bottom="0"
                      ml="10"
                      mb="8"
                      className="bg-gray-200 rounded-full text-xs"
                    >
                      CF-0000{1 + i} | {formatDollar(product.pricePerAcre)}
                    </Text>
                    <Box
                      className="text-cf-300 font-semibold"
                      bg="white"
                      p="4"
                      textAlign="center"
                      mt="1"
                    >
                      <Text className="text-xs">
                        Starts On: {moment(product.startDate).format('L')}
                      </Text>
                    </Box>
                  </Box>
                  <Button
                    click={() =>
                      history.push({
                        pathname: '/start-farm',
                        state: { step: 1, product }
                      })
                    }
                    className="w-full bg-cf-300 text-white text-xs px-4 py-3 md:text-lg md:px-10 md:py-4 rounded"
                    name="Start this Farm"
                  />
                </>
              ) : product.status === 1 ? (
                <>
                  <Box className="shadow-cfw rotate-345" pos="relative" mb="3">
                    <Box bg="white" textAlign="center" className="rounded-md" p="4">
                      <Text className="text-sm" fontWeight="bold">
                        {product.crop.name}
                      </Text>
                      <Text as="span" className="text-xs">
                        {product.acreage} Acres
                      </Text>
                      <Image
                        w="32"
                        mx="auto"
                        mb="4"
                        src={product.crop.imageUrl}
                        alt={product.crop.name}
                      />
                    </Box>
                    <Text
                      as="span"
                      p="2"
                      pos="absolute"
                      bottom="0"
                      ml="10"
                      mb="12"
                      className="bg-gray-200 rounded-full text-xs"
                    >
                      CF-0000{1 + i} | {formatDollar(product.pricePerAcre)}
                    </Text>
                    <Box
                      bg="white"
                      p="4"
                      textAlign="center"
                      mt="1"
                      className="text-cf-300 font-semibold"
                    >
                      <Text className="text-xs">Upcoming Season</Text>
                      <Text className="text-xs">
                        Starts On: {moment(product.startDate).format('L')}
                      </Text>
                    </Box>
                  </Box>
                </>
              ) : null}
            </Box>
          ))}
        </Flex>
      </Box>
    </Box>
  );
};

export default AddFarm;
